import { render, staticRenderFns } from "./MagnificationSelector.vue?vue&type=template&id=5eb8cac6&scoped=true"
import script from "./MagnificationSelector.vue?vue&type=script&lang=js"
export * from "./MagnificationSelector.vue?vue&type=script&lang=js"
import style0 from "./MagnificationSelector.vue?vue&type=style&index=0&id=5eb8cac6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb8cac6",
  null
  
)

export default component.exports